const degrees = [
  {
    school: 'TU Wien',
    degree: 'Dr. techn. Informatics (in progress)',
    link: 'https://www.tuwien.at',
    year: 2026,
  },
  {
    school: 'University of California, San Diego',
    degree: 'PhD in Political Science (interrupted after completing the MA)',
    link: 'https://ucsd.edu',
    year: 2019,
  },
  {
    school: 'University of California, San Diego',
    degree: 'M.I.A. Methodology and International Affairs, School of Global Policy and Strategy',
    link: 'https://gps.ucsd.edu',
    year: 2017,
  },
  {
    school: 'University of CEMA',
    degree: 'B.A. International Relations (double major in Economics)',
    link: 'https://ucema.edu.ar',
    year: 2013,
  },
];

export default degrees;
